import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import { FRONT_PLANS, PLANS_MODE } from 'Constants/plans';
import * as Styled from './styles';

interface PlanPriceProps {
  finalPrice: string;
  service: string;
  userHaveDiscount: boolean;
  realPrice: string;
}

const PlanPrice = ({
  finalPrice,
  service,
  userHaveDiscount,
  realPrice,
}: PlanPriceProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  return (
    <FlexContainer direction="column" align="center">
      <Styled.PriceContainer gap="dimension_08">
        {userHaveDiscount && service !== PLANS_MODE[FRONT_PLANS.FLEX] && (
          <Styled.DiscountPrice type="paragraphs" size="XL_M_S" color="danger_strong">
            {YayoyakiFormatter.formatAmountMxn(parseInt(realPrice, 10))}
          </Styled.DiscountPrice>
        )}
        <Text type="paragraphs" size="M_L_S" color="dark">
          {service === PLANS_MODE[FRONT_PLANS.FLEX] ? (
            <Trans
              i18nKey="Plans.price.devolution"
              components={{
                amount: <Styled.Price />,
              }}
              ns="plans"
            />
          ) : (
            <Trans
              i18nKey="Plans.price.installments"
              values={{
                amount: YayoyakiFormatter.formatAmountMxn(parseInt(finalPrice, 10)),
              }}
              components={{
                text: <Styled.Price />,
              }}
              ns="plans"
            />
          )}
        </Text>
        {userHaveDiscount && service === PLANS_MODE[FRONT_PLANS.FLEX] && (
          <Styled.DiscountText type="paragraphs" size="M_M_S" color="danger_strong">
            {t('Plans.flex.discount')}
          </Styled.DiscountText>
        )}
      </Styled.PriceContainer>
    </FlexContainer>
  );
};

export default PlanPrice;
